<template>
  <div class="manifestacao-form">
    <div class="columns manifestacao-form-layout is-align-items-stretch">
      <div class="column manifestacao-form-campos">
        <slot />
      </div>
      <slot name="upload" />
    </div>
    <div v-if="$slots.actions" class="manifestacao-form-actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ManifestacaoFormLayout',
};
</script>

<style src="@/styles/manifestacao.scss" lang="scss" scoped />
